import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  SimpleChanges,
  SecurityContext,
} from '@angular/core';
import { UtilService } from 'src/app/util/util.service';
import { CROSS_ORDER, BANNER_MASCOT } from 'src/defaultImages.js';
import { EasyEatHqService } from '../../services/ee-hq.service';
import { LocalStorageService } from '../../services/localStorage.service';
import { DateService } from '../../services/date.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CollectionInfrastructureService } from 'src/app/collection-infrastructure/collection-infrastructure.service';
import { CollectionInfrastructureHelperService } from 'src/app/collection-infrastructure/collection-infrastructure-helper.service';

@Component({
  selector: 'app-payment-banner',
  templateUrl: './payment-banner.component.html',
  styleUrls: ['./payment-banner.component.css'],
})
export class PaymentBannerComponent implements OnInit, OnDestroy {
  FOUR_HOURS = 145800000; // 4 hours in milliseconds

  @Input() negativeBalance;
  @Input() restaurantId;

  images = {
    CROSS: CROSS_ORDER,
    BANNER_MASCOT: BANNER_MASCOT,
  };
  balanceArray: any = [];
  isHq;
  paymentDetails: any = {};
  currentMonth;
  dateToText = {};
  translationText: any;
  paymentText: string = '';
  currentDayOfMonth;
  dismissBanners: boolean = false;
  apiCalledSuccessfully: boolean = false;
  showBanner: boolean = false;
  loading: boolean = false;
  color: string = '#1b3644';
  private intervalId: any; // Variable to store the interval ID

  constructor(
    private _util: UtilService,
    public _translateService: TranslateService,
    private _collectionInfraService: CollectionInfrastructureService,
    private _ciHelperService: CollectionInfrastructureHelperService,
    private _hqService: EasyEatHqService,
    private _dialog: MatDialog,
    private _localStorage: LocalStorageService,
    private _modalService: NzModalService,
    private _sanitizer: DomSanitizer,
    private _dateService: DateService
  ) {
    this.isHq = this._hqService.isHqUser();
    this.currentMonth = this._dateService.returnLastDateMonth();
  }

  ngOnInit() {
    this._localStorage.watch('hq_id').subscribe((_) => {
      const hqId = this._localStorage.get('hq_id');
      if (hqId && this.isHq) {
        this.callApiEveryFourHours();
      }
    });
    const currentDate = new Date();
    this.currentDayOfMonth = currentDate.getDate(); // Get the current day of the month (1-31)
    this.getColor();
    this.setTranslation();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.negativeBalance && changes.restaurantId && !this.isHq) {
      // Call the function initially when the component is initialized
      this.callApiEveryFourHours();
    }
  }
  sanitizeHtml(html: string): SafeHtml {
    return this._sanitizer.sanitize(SecurityContext.HTML, html);
  }

  ngOnDestroy() {
    // Clear the interval when the component is destroyed to avoid memory leaks
    clearInterval(this.intervalId);
  }
  // to get banner color
  getColor() {
    if (this.currentDayOfMonth > 11) {
      this.color = '#FF4F4F';
    } else if (this.isHq) {
      this.color = '#FCBD5F';
    } else {
      this.color = '#1b3644';
    }
  }
  // update text for the banner
  getCurrentDayOfMonthText() {
    this.paymentText =
      this.dateToText[this.currentDayOfMonth] || this.translationText.DEFAULT;
  }
  // set translation
  setTranslation() {
    this._translateService.get(['ORDER_DASHBOARD']).subscribe((translation) => {
      this.translationText = translation.ORDER_DASHBOARD;
      const currentMonthText = `${this.translationText.PENDING_PAYMENT_DAY1} <span class="fw-600">${this.currentMonth}</span>`;
      const day5To9Text = `${this.translationText.PENDING_PAYMENT_DAY5} <span class="fw-600">${this.currentMonth}</span> ${this.translationText.PENDING_PAYMENT_DAY5_2}`;
      const day10Text = `${this.translationText.PENDING_PAYMENT_DAY10} <span class="fw-600">${this.currentMonth}</span> ${this.translationText.PENDING_PAYMENT_DAY10_2}`;
      const day12Text = `${this.translationText.PENDING_PAYMENT_DAY12} <span class="fw-600">${this.currentMonth}</span> ${this.translationText.PENDING_PAYMENT_DAY12_2}`;
      const day13Text = `${this.translationText.PENDING_PAYMENT_DAY13} <span class="fw-600">${this.currentMonth}</span> ${this.translationText.PENDING_PAYMENT_DAY13_2}`;
      const day14Text = `${this.translationText.PENDING_PAYMENT_DAY14} <span class="fw-600">${this.currentMonth}</span> ${this.translationText.PENDING_PAYMENT_DAY14_2}`;
      const day15Text = `${this.translationText.PENDING_PAYMENT_DAY15} ${this.translationText.PENDING_PAYMENT_DAY15_2}`;
      this.dateToText = {
        '1': currentMonthText,
        '2': currentMonthText,
        '3': currentMonthText,
        '4': currentMonthText,
        '5': day5To9Text,
        '6': day5To9Text,
        '7': day5To9Text,
        '8': day5To9Text,
        '9': day5To9Text,
        '10': day10Text,
        '11': day10Text,
        '12': day12Text,
        '13': day13Text,
        '14': day14Text,
        '15': day15Text,
      };
      this.getCurrentDayOfMonthText();
    });
  }
  // remove banner for four hours
  dismissBanner() {
    this._collectionInfraService
      .dismissBanner(this.restaurantId, this.isHq)
      .then((isDismissed) => {
        if (isDismissed) {
          this.dismissBanners = true;
          this.intervalId = setInterval(() => {
            this.apiCalledSuccessfully = false;
            this.callApiEveryFourHours();
          }, this.FOUR_HOURS);
        }
      })
      .catch((error) => {
        console.error(error);
        // Implement error handling here (e.g., show a user-friendly error message)
      });
  }
  // api to check if we can show banner or not
  async callApiEveryFourHours() {
    const currentDate = new Date();
    if (this.apiCalledSuccessfully || (!this.negativeBalance && !this.isHq))
      return;
    this.loading = true;
    const api = this.isHq
      ? { apiKey: 'getHqBalance', id: this._localStorage.get('hq_id') }
      : { apiKey: 'getBannerDetails', id: this.restaurantId };

    try {
      const response = await this._collectionInfraService[api.apiKey](api.id);

      if ((response || {}).status === 1) {
        this.apiCalledSuccessfully = true;
        this.paymentDetails = (response || {}).data || {};
        this._localStorage.set('isBalanceExpired', this.paymentDetails.expired || false)

        const text = `${this.translationText.GET_BUSY} <span class="fw-600">${
          (this.paymentDetails || {}).extraDays
        }</span> ${
          this.translationText.MORE_DAYS
        } <span class="fw-600">${this._dateService.addSuffixToDay(
          currentDate.getDate() + (this.paymentDetails || {}).extraDays
        )}</span> ${this.translationText.GOT_YOUR_BACK}`;

        if ((this.paymentDetails || {}).extraDays) {
          this.paymentText = text;
        }
        if ((this.paymentDetails || {}).message) {
          this.paymentText = (this.paymentDetails || {}).message;
        }

        if (this.isHq) {
          this.showBanner = !!(this.paymentDetails || {}).length;
          this.dismissBanners = ((response || {}).metaData || {}).dismissBanner;
        } else {
          this.showBanner = (this.negativeBalance && (this.paymentDetails || {}).nbBannerType === 0);
          this._localStorage.set(
            'nbBannerType',
            (this.paymentDetails || {}).nbBannerType || ''
          );
          this.dismissBanners = ((response || {}).data || {}).bannerDismissed;
          this.currentMonth = `${(this.paymentDetails || {}).month || ''} ${
            (this.paymentDetails || {}).year || ''
          }`;
        }

        if (this.dismissBanners) clearInterval(this.intervalId);
        if ((this.paymentDetails || {}).locked && !this.isHq) {
          if (this.checkRestaurantLockedManually()) {
            this.lockedAfterPromiseBanner();
          } else {
            this.lockedBanner()
          }
          // } else if (
          //   this.paymentDetails.bannerType === NEGATIVE_BALANCE_ENUM.PROMISE
          // ) {
          //   this.lockedBanner();
          // } else if (
          //   this.paymentDetails.bannerType === NEGATIVE_BALANCE_ENUM.LITE
          // ) {
          //   this.lockedAfterPromiseBanner();
          // }
        }
      } else {
        this.showBanner = false;
        this._localStorage.remove('isBalanceExpired')
        this._localStorage.remove('nbBannerType')

      }
    } catch (error) {
      console.error(error);
      // Implement error handling here (e.g., show a user-friendly error message)
    } finally {
      this.loading = false;
    }
  }

  // modal for payment of hq rest
  async viewBill() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    try {
      const dataArr = await (this.paymentDetails || {});
      const { ViewBillComponent } = await import(
        /* webpackPrefetch: true */
        'src/app/pos-order/modals/view-bill/view-bill.component'
      );
      this._dialog.open(ViewBillComponent, {
        backdropClass: 'backdrop',
        disableClose: true,
        maxHeight: '100vh',
        maxWidth: '100vw',
        data: {
          date: this.currentMonth,
          dataArr,
        },
      });
    } catch (error) {
      console.error(error);
      // Implement error handling here (e.g., show a user-friendly error message)
    }
  }

  showPayment() {
    if (!this.isHq) {
      this._ciHelperService.redirectToSubscriptionPage()
    } else {
      this.viewBill();
    }
  }
  // screen is locked
  async lockedBanner() {
    let popupData = this.paymentDetails;
    const { LockedPosComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/shared/shared modal/locked-pos/locked-pos.component'
    );
    const modal = this._modalService.create({
      nzClosable: false,
      nzContent: LockedPosComponent,
      nzBodyStyle: { padding: '0px' },
      nzFooter: null,
      nzWidth: 650,
      nzMaskClosable: false,
      nzComponentParams: { popupData },
      nzKeyboard: false, // Add this line to disable closing on ESC button
      nzCentered: true
    });
    modal.afterClose.subscribe((response) => {
      if ((response || {}).success) {
        this.apiCalledSuccessfully = false;
        this.callApiEveryFourHours();
      }
    });
  }

  async lockedAfterPromiseBanner() {
    let popupData = this.paymentDetails;
    const { LockedPosAfterPromiseComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/shared/shared modal/locked-pos-after-promise/locked-pos-after-promise.component'
    );
    const modal = this._modalService.create({
      nzClosable: false,
      nzContent: LockedPosAfterPromiseComponent,
      nzBodyStyle: { padding: '0px' },
      nzFooter: null,
      nzWidth: 650,
      nzMaskClosable: false,
      nzComponentParams: { popupData },
      nzStyle: { top: '45px' },
      nzKeyboard: false, // Add this line to disable closing on ESC button
    });
    modal.afterClose.subscribe((response) => {
      if ((response || {}).success) {
        this.apiCalledSuccessfully = false;
        this.callApiEveryFourHours();
      }
    });
  }

  checkRestaurantLockedManually(): boolean {
    const restSettings = this._util.getRestaurantSettings() || {};
    const isLiteLocked = !!((restSettings.global || {}).is_pos_locked || 0);
    return isLiteLocked;
  }
}
